<template>
  <ais-instant-search index-name="alg_properties" :search-client="searchClient">
    <ais-configure :hits-per-page.camel="5">
      <ais-autocomplete>
        <template v-slot="{ currentRefinement, indices, refine }">
          <form
            class="flex justify-center md:hidden"
            @submit.prevent="redirectListFarm(currentRefinement)"
          >
            <div class="input__field">
              <input
                type="text"
                class="search-bar search-algolia w-full text-sm font-dinpro font-medium"
                placeholder="Buscar"
                :value="currentRefinement"
                :class="{ 'search-bar-border': currentRefinement }"
                @keyup="refine($event.currentTarget.value)"
                id="search-mobile"
              />
              <span
                v-if="currentRefinement"
                id="closeSearch"
                class="icon-x text-agrogo-yellow-1 icon_x search-algolia"
                @click.prevent="refine(($event.currentTarget.value = ''))"
              ></span>
            </div>
            <button
              type="submit"
              class="icon-search-bar text-agrogo-green-2 search-algolia"
              :class="{ 'icon-search-bar-boder': currentRefinement }"
              @click.prevent="
                redirectListFarm(currentRefinement),
                  refine(($event.currentTarget.value = ''))
              "
            ></button>
          </form>
          <div id="list-search" v-if="currentRefinement">
            <div v-for="index in indices" :key="index.indexId">
              <div
                class="md:flex md:flex-row bg-white px-1 pb-1 space-y-2 flex-wrap"
              >
                <div class="w-full bg-agrogo-green-2">
                  <div class="h-9 pt-2 bg-white">
                    <p
                      class="text-base font-dinpro font-normal text-agrogo-black-1 text-left pl-6"
                    >
                      Se han encontrado
                      {{ index.hits.length }} resultados
                    </p>
                  </div>
                  <div class="search-home-style">
                    <div
                      v-for="item in index.hits"
                      :key="item.objectID"
                      class="bg-agrogo-green-5 cursor-pointer"
                      @click.prevent="
                        sendDetail(item),
                          refine(($event.currentTarget.value = ''))
                      "
                    >
                      <div class="bg-agrogo-green-2">
                        <div
                          :id="'style-search-home' + item.id"
                          class="container-search-home"
                        >
                          <div class="flex px-3 py-2 gap-x-4">
                            <div class="h-auto flex items-center">
                              <div class="flex flex-col space-y-1">
                                <p
                                  class="text-xs text-white text-left font-nexa font-normal"
                                >
                                  {{ item.name }}
                                </p>
                                <div
                                  class="grid grid-cols-4 place-content-center place-items-center gap-x-1"
                                >
                                  <span
                                    v-for="category in item.alg_categories.slice(
                                      0,
                                      3
                                    )"
                                    :key="category.id"
                                    class="text-agrogo-yellow-1 text-lg"
                                    :class="category.icon_subcategory"
                                  ></span>
                                  <span
                                    v-if="item.alg_categories.length > 3"
                                    class="text-agrogo-yellow-1 text-2xl"
                                  >
                                    ...
                                  </span>
                                </div>
                              </div>
                            </div>
                            <div class="flex flex-col justify-between">
                              <p
                                class="flex items-start justify-end text-xs md:text-base font-dinpro font-normal opacity-80"
                              >
                                <span>ID#</span>
                                {{ item.property_id }}
                              </p>
                              <div class="flex flex-col items-end justify-end">
                                <span class="font-nexa font-normal text-xs"
                                  >Precio Total
                                </span>
                                <p
                                  class="flex text-left text-base md:text-2xl font-dinpro font-normal leading-4"
                                >
                                  <span
                                    class="icon-signo-pesos text-sm md:text-xl mr-1 mt-1 leading-3"
                                  ></span>
                                  {{ formatThousand(item.price) }}
                                </p>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </template>
      </ais-autocomplete>
    </ais-configure>
  </ais-instant-search>
</template>

<script>
// Algolia
import algoliasearch from "algoliasearch/lite";

export default {
  data() {
    const algoliaId =
      process.env.VUE_APP_DEBUG == "true"
        ? process.env.VUE_APP_ALGOLIA_ID_TEST
        : process.env.VUE_APP_ALGOLIA_ID;
    const algoliaPrivateKey =
      process.env.VUE_APP_DEBUG == "true"
        ? process.env.VUE_APP_PRIVATE_KEY_ALGOLIA_TEST
        : process.env.VUE_APP_PRIVATE_KEY_ALGOLIA;
    return {
      searchClient: algoliasearch(algoliaId, algoliaPrivateKey),
    };
  },
  methods: {
    formatThousand(number) {
      const formatterPeso = new Intl.NumberFormat("es-CO", {
        currency: "COP",
        minimumFractionDigits: 0,
      });
      number = formatterPeso.format(number);
      return number;
    },
    sendDetail(item) {
      const me = this;
      me.$router.push({ name: "FarmDetail", params: { slug: item.slug } });
    },
    redirectListFarm(text) {
      const me = this;
      if (text) {
        me.$router.push({
          name: "ListOfFarms",
          query: { buscar: text },
        });
      }
      const search = document.getElementById("search-mobile");
      search.blur();
    },
  },
};
</script>

<style lang="css" scoped>
.ais-InstantSearch {
  z-index: 5 !important;
}
.search-bar-border {
  border-top-left-radius: 1.5rem;
  border-bottom-left-radius: 0rem;
}
.icon-search-bar-boder {
  border-top-right-radius: 1.5rem;
  border-bottom-right-radius: 0rem;
}
input::placeholder {
  opacity: 0.5;
  color: #5d5d5d;
}
.input__field {
  width: 100%;
  display: flex;
  position: relative;
}
.icon_x {
  position: absolute;
  left: 12px;
  top: 50%;
  transform: translateY(-50%);
  font-size: 15px;
  left: unset;
  right: 12px;
  cursor: pointer;
}
</style>
